import type { IdToFieldSelectionContext, ResolvedFieldSelectionContext } from '#layers/data-model/public';
import { useNuxtApp } from '#app/nuxt';
import { getBlockConfig } from '#layers/block-engine/public';
import { getDisplayTemplateFieldSelection, useWorkspaceSchemaStore } from '#layers/data-model/public';

export function useFieldSelectionContexts() {
	const workspaceSchema = useWorkspaceSchemaStore();
	const { findCollectionById, findPrimitiveFieldById, findSingleRelationFieldById } = workspaceSchema;
	const { getBlock } = useNuxtApp().$fieldDisplayBlockResolver;

	const fieldSelectionCtx: ResolvedFieldSelectionContext = {
		getDisplayTemplateFieldSelection: (ast, collection) =>
			getDisplayTemplateFieldSelection(ast, collection, fieldSelectionCtx),
		getCollection: findCollectionById,
		getRelationField: findSingleRelationFieldById,
		resolveDisplayBlock: (displayId) => {
			const block = getBlock(displayId);
			if (block && 'comp' in block) return getBlockConfig(block);
		},
		getQuerySchema: () => workspaceSchema.querySchema,
	};

	const idCtx: IdToFieldSelectionContext = {
		findPrimitiveFieldById,
		findSingleRelationFieldById,
	};

	return { fieldSelectionCtx, idCtx };
}
